"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDepositExpectedForOrder = isDepositExpectedForOrder;
const constants_1 = require("@daytrip/constants");
const utils_1 = require("@daytrip/utils");
function isDepositExpectedForOrder(order) {
    if ((0, utils_1.isPapiBooking)(order.paymentMethod)) {
        return false;
    }
    return (constants_1.CASH_ONLY_COUNTRIES.includes(order.pricingCountryId) ||
        (order.totalPrice && order.totalPrice >= constants_1.ORDER_CONFIRMATION_TOTAL_CONSTRAINT));
}
//# sourceMappingURL=isDepositExpectedForOrder.js.map